import {twMerge} from 'tailwind-merge';
import {clsx, ClassValue} from 'clsx';

/**
 * Helper function to merge Tailwind CSS classes with custom classes
 */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
